import { Check, CircleHelp, GitMerge, GitPullRequestClosed, LoaderCircle, X } from 'lucide-react'
import { useGetPullRequestChecksQuery } from '../services/projectDataApi'
import './PullRequestCheckStatus.css'

export default function PullRequestCheckStatus({ projectId, repo, pr }: { projectId: string; repo: string; pr: number }) {
  const { data, isLoading, isError } = useGetPullRequestChecksQuery({ projectId, repo, pr }, {
    pollingInterval: 30_000,
    skipPollingIfUnfocused: true,
    refetchOnMountOrArgChange: 30,
  })
  const state = !isError && !isLoading ? data?.state : undefined
  const status = state === 'merged' || state === 'closed' ? state
    : isError ? 'unknown' : isLoading ? 'pending' : data?.status ?? 'unknown'
  const label = {
    merged: 'Merged',
    closed: 'Closed without merge',
    success: 'Checks passed',
    failure: 'One or more checks failed',
    pending: isLoading ? 'Loading check status' : 'Checks in progress',
    unknown: 'Check status unavailable or no checks reported',
  }[status]
  const Icon = { merged: GitMerge, closed: GitPullRequestClosed, success: Check, failure: X, pending: LoaderCircle, unknown: CircleHelp }[status]
  const description = state === 'open' ? `Open pull request. ${label}` : label
  const title = status === 'merged' || status === 'closed' ? label
    : `${description}. Includes GitHub checks and commit statuses, including reported QA checks.`
  return <span className={`pr-check-status pr-check-status--${status}`} title={title} role="img" aria-label={description}>
    <Icon size={14} aria-hidden="true" />
  </span>
}
